import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";
import swal, {SweetAlertOptions} from "sweetalert2";
import {CnaService} from "../../../../clearpath-module/services/cna.service";
import {CdkDragDrop, moveItemInArray, transferArrayItem} from "@angular/cdk/drag-drop";

@Component({
    selector: 'app-customer-priorities-dialog',
    templateUrl: './customer-priorities-dialog.component.html',
    styleUrls: ['./customer-priorities-dialog.component.scss']
})
export class CustomerPrioritiesDialogComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<CustomerPrioritiesDialogComponent>,
        public cnaService: CnaService,
    ) {
    }

    ngOnInit(): void {
        this.cnaService.resetForm();
    }

    close() {
        this.dialogRef.close();
    }

    getOptionIcon(option: string): string {
        return "/static/images/cna_icons/" + (option.toLowerCase().replace(' ', '_')) + '.png';
    }

    drop(event: CdkDragDrop<string[]>) {
        // console.log("Event:", event)
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            if (event.container.id === "targetList") {
                // console.log("Target list length:", event.container.data.length)
                if (event.container.data.length >= 4) {
                    // console.log("Target list too long! Not adding Item");
                    swal.fire({
                        title: "Maximum Priorities Reached",
                        html: "A maximum of 4 customer priorities is permitted at once.  Please remove a priority before adding a new one to the list.",
                        icon: "warning",
                        showConfirmButton: true,
                        confirmButtonText: "OK",
                    } as SweetAlertOptions).then();
                    return;
                }
            }
            transferArrayItem(event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex);
        }
    }
}
